import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import first from 'lodash/first';

import { useDispatch, useSelector } from 'react-redux';

import { RadioGroup, Radio, Button, ButtonColor, Card, CardBody, Hyperlink } from 'react-magma-dom';
import { HelpIcon } from 'react-magma-icons';

import { setTypeOfUploadDataset } from 'store/scenes/dataSet';
import { getTypeOfUploadDataset } from 'store/scenes/dataSet/selectors';
import { radioGroup, RAW } from '../../constants';
import { setErrorTypeOfUploadDataset } from '../../../../../store/scenes/dataSet';

const renderErrorMessage = typeOfUploadDataset => {
  return (
    <div>
      <span className="error-message">
        <span>Your dataset is not formatted as a {typeOfUploadDataset} {typeOfUploadDataset === RAW ? 'dataset' : 'table'}.
          For help choosing the correct dataset type, see
        </span>
        {' '}
        <Hyperlink to="https://www.cengage.com/help/salt/?t=dataset-types" target="_blank">
          SALT Help
        </Hyperlink>
        <span>.</span>
      </span>
    </div>
  );
};

const Content = props => {
  const { onFileChange, onClose, isErrorType } = props;
  const typeOfUploadDataset = useSelector(state => getTypeOfUploadDataset(state));
  const initialValue = typeOfUploadDataset ? typeOfUploadDataset : RAW;

  const [requiredFieldsValue, setRequiredFieldsValue] = useState(initialValue);
  const [isFileTypeError, setIsFileTypeError] = useState(false);
  const dispatch = useDispatch();

  const fileInputRef = useRef();

  const changeTypeOfUploadTable = event => {
    const type = event.target.value;
    setIsFileTypeError(false);
    dispatch(setErrorTypeOfUploadDataset(false));
    setRequiredFieldsValue(type);
  };

  const getFileExtension = file => file.name.split('.').pop().toLowerCase();

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  const handleChange = event => {
    const { target } = event;
    const file = first(target.files);
    if (getFileExtension(file) !== 'csv') {
      setIsFileTypeError(true);
      target.value = null;
      return;
    }
    dispatch(setTypeOfUploadDataset(requiredFieldsValue));
    onFileChange(file, requiredFieldsValue);


    target.value = null;
  };
  return (
    <div>
      <Card>
        <CardBody>
          <RadioGroup
            required
            name="typeOfUploadTable"
            onChange={changeTypeOfUploadTable}
            value={initialValue}
            labelledById="labelForRadioGroup"
          >
            <div className="flex align-center">
              <h2 className="sub-header-page" id="labelForRadioGroup">Choose a dataset type</h2>
              <Hyperlink to="https://www.cengage.com/help/salt/?t=dataset-types" target="_blank">
                <HelpIcon aria-hidden="true" />
              </Hyperlink>
            </div>
            {radioGroup.map(item =>
              <Radio key={item.value} labelText={item.labelText} value={item.value} labelStyle={{ marginLeft: '-5px' }} />
            )}
          </RadioGroup>
          {isErrorType && renderErrorMessage(typeOfUploadDataset)}
          {isFileTypeError && !isErrorType && renderErrorMessage(requiredFieldsValue)}
        </CardBody>
      </Card>
      <br />
      <div className="flex justify-end">
        <Button
          style={{ fontSize: 14 }}
          className="align-end"
          aria-label="Cancel"
          onClick={onClose}
          color={ButtonColor.secondary}
          testId="cancel-upload-files"
        >CANCEL
        </Button>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          onChange={handleChange}
          className="upload-files__btn"
        />
        <div className="upload-files">
          <Button
            style={{ fontSize: 14 }}
            aria-label="Upload"
            onClick={handleUploadClick}
          >
            Upload
          </Button>
        </div>
      </div>
    </div>
  );
};

Content.propTypes = {
  isErrorType: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onFileChange: PropTypes.func.isRequired
};

export default Content;
